import Vue from 'vue'
import jwt_decode from 'jwt-decode'
import Swal from 'sweetalert2'
import apis from '../../models/apis'

Vue.mixin({
  data() {
    return {}
  },
  methods: {
    checkDevice() {
      // production
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        let platform = navigator.platform.toLowerCase()
        if (platform !== '' && platform.search('win') === -1 && platform.search('mac') === -1) {
          return true
        }
        return false
      }
      return false

      // development
      // return true
    },
    async checkOAuth() {
      if (this.checkDevice() === true) {
        if (localStorage.refresh_token !== undefined) {
          if (localStorage.access_token !== undefined) {
            let jwt = jwt_decode(localStorage.access_token)
            if (jwt !== null) {
              let current_time = parseInt(new Date().getTime() / 1000)
              let expire_time = parseInt(jwt.expire)
              if (current_time > expire_time) {
                await this.getRefreshToken()
              }
            } else {
              await this.getRefreshToken()
            }
          } else {
            await this.getRefreshToken()
          }
          if (this.$route.name === 'login') {
            window.location = '/checkin'
          }
        } else {
          this.logOut()
        }
      } else {
        this.$router.push('/error').catch(() => {})
      }
    },
    getRefreshToken() {
      this.$store.state.is_loading = true
      apis.OAuth(
        this.$store.state.api_url,
        { agent: navigator.userAgent + ' Platform: ' + navigator.platform },
        { headers: { 'Access-Token': `${localStorage.refresh_token}` } },
        result => {
          if (result.response === true) {
            localStorage.access_token = result.access_token
            this.$store.state.is_loading = false
          } else {
            this.$store.state.is_loading = false
            this.logOut()
          }
        },
        error => {
          this.$store.state.is_loading = false
          this.logOut()
          console.log(error)
        }
      )
    },
    logOut() {
      if (this.$route.name !== 'login') {
        Swal.fire({
          title: 'ไม่สามารถทำรายการได้',
          text: 'เซสชั่นหมดอายุ เข้าสู่ระบบใหม่อีกครั้ง',
          icon: 'error',
          confirmButtonColor: '#F43131',
          confirmButtonText: 'เข้าสู่ระบบ',
          showCancelButton: false,
          allowOutsideClick: false
        }).then(result => {
          if (result.isConfirmed) {
            localStorage.clear()
            this.$router.push('/login').catch(() => {})
          }
        })
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/oauth.js